import styled from 'styled-components';
import { typography } from '@cld/typography';
import { maxWidthVariant, tooltipTheme, TooltipThemeProps } from './theme';

export const TooltipPaper = styled.div<TooltipThemeProps>`
  background: ${tooltipTheme.paper.background};
  ${typography.xxs.regular};
  color: ${tooltipTheme.paper.color};
  border-radius: ${tooltipTheme.paper.border.radius};
  padding: ${tooltipTheme.paper.padding};
  max-width: ${maxWidthVariant((variant) => variant.maxWidth)};
  overflow-wrap: break-word;
`;
